import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

function OrderFormPackagingDetails(props) {
  return (
    <React.Fragment>

      <Grid item sm={12}>
        <Typography variant="overline">Product Packaging Details</Typography>
        <div style={{ borderBottom: '1px dashed black' }}></div>
      </Grid>

      <Grid item sm={3}>
        <TextField required fullWidth type="number" size="small" label="Width"
          onFocus={(evt) => evt.target.select()} value={props.data.width}
          onChange={(evt) => props.onChange('width', +evt.target.value)}
          InputProps={{
            endAdornment: <InputAdornment position="end">in</InputAdornment>,
          }}
        />
      </Grid>
      <Grid item sm={3}>
        <TextField required fullWidth type="number" size="small" label="Length"
          onFocus={(evt) => evt.target.select()} value={props.data.length}
          onChange={(evt) => props.onChange('length', +evt.target.value)}
          InputProps={{
            endAdornment: <InputAdornment position="end">in</InputAdornment>,
          }}
        />
      </Grid>
      <Grid item sm={3}>
        <TextField required fullWidth type="number" size="small" label="Height"
          onFocus={(evt) => evt.target.select()} value={props.data.height}
          onChange={(evt) => props.onChange('height', +evt.target.value)}
          InputProps={{
            endAdornment: <InputAdornment position="end">in</InputAdornment>,
          }}
        />
      </Grid>
      <Grid item sm={3}>
        <TextField required fullWidth type="number" size="small" label="Weight"
          onFocus={(evt) => evt.target.select()} value={props.data.weight}
          onChange={(evt) => props.onChange('weight', +evt.target.value)}
          InputProps={{
            endAdornment: <InputAdornment position="end">oz</InputAdornment>,
          }}
        />
      </Grid>

    </React.Fragment>
  );
}

export default OrderFormPackagingDetails;
